import { ZipCode, IZipCode } from '@common/models/ZipCode';
import { http } from '@common/utils';
import { trackPromise } from 'react-promise-tracker';
import { ServiceHelper } from '../serviceHelper';
import { ServiceMethodOptions } from '../types';

export class ZipCodeService {
    private static baseUrl: string = '/api/zipcode/';
    static tags = {
        upsertZipCode: "upsertZipCode",        
        deleteZipCode: "deleteZipCode",          
    }

    static getZipCodeByZipcode = (zipCode: string): Promise<IZipCode | undefined> => {
        if (!zipCode || zipCode.length < 5) {
            return Promise.resolve(undefined);
        } else {
            return trackPromise(
                http(`${this.baseUrl}${zipCode}`).get<IZipCode>()
            );
        }
    };    

    static upsertZipCode = (data: IZipCode, options?: ServiceMethodOptions): Promise<ZipCode> => {
        return trackPromise(new Promise<IZipCode>((resolve, reject) => {
            http(`${this.baseUrl}`).post<IZipCode>(data)
                .then((response) => {
                    ServiceHelper.showSuccess("Zip Code updated.", options);
                    resolve(new ZipCode(response));
                })
                .catch((err) => {
                    ServiceHelper.showError("Failed to update Zip Code.", options);
                    reject(err);
                })
        }), this.tags.upsertZipCode);
    }
    static deleteZipCode = (zipCodeId: number, options?: ServiceMethodOptions): Promise<boolean> => {
        return trackPromise(new Promise<boolean>((resolve, reject) => {
            http(`${this.baseUrl}${zipCodeId}`).delete()
                .then(() => {
                    ServiceHelper.showSuccess("Zip Code has been deleted.", options);
                    resolve(true);
                })
                .catch((err) => {
                    ServiceHelper.showError("Failed to delete Zip Code.", options);
                    reject(err);
                })
        }), this.tags.deleteZipCode);
    }       
}
